import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";

const initialState: State = {
  isPending: false,
  isSuccessful: false,
  isFailure: false,
};

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.addPlanzoneVirtualResourceRequested]: setRequestStateToPending,
    [events.addPlanzoneVirtualResourceSucceeded]: setRequestStateToSuccess,
    [events.addPlanzoneVirtualResourceFailed]: setRequestStateToFailure,
  }),
  [events.changePlanzoneSucceeded],
);

function createSelector(getState: () => State): Selector {
  return {
    isAddPlanzoneVirtualResourceRequestFailure() {
      return getState().isFailure;
    },
    isAddPlanzoneVirtualResourceRequestPending() {
      return getState().isPending;
    },
    isAddPlanzoneVirtualResourceRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
